import { CoreCapsuleWithAccount } from 'entities'
import { useResponsive } from 'hooks'
import { formatBigNumber } from 'utils'
import { IInfoItemProps } from './InfoItem'
import { InfoItemsBundle } from './InfoItemsBundle'

export interface IBottomStatsProps {
  coreCapsule: CoreCapsuleWithAccount
}

export const BottomStats = ({ coreCapsule }: IBottomStatsProps) => {
  const { width } = useResponsive()
  const isMobile = width < 800

  const infoItems: IInfoItemProps[] = [
    {
      label: 'Interest rate',
      tooltip: 'Annualized percent your debt will increase each year',
      value: `${formatBigNumber(coreCapsule.yearlyInterestRate.mul(100), 2)}%`,
    },
    {
      label: 'Borrow fee',
      tooltip: 'Fee added to your debt every time you borrow from ARCx',
      value: `${formatBigNumber(coreCapsule.borrowFee.mul(100), 2)}%`,
    },
    {
      label: 'Liquidation fee',
      tooltip: 'Discount liquidators get when purchasing collateral flagged for liquidation',
      value: `${formatBigNumber(coreCapsule.liquidationFee.mul(100), 2)}%`,
    },
  ]

  return <InfoItemsBundle isMobile={isMobile} items={infoItems} />
}
